module.exports = __webpack_public_path__ + "r-v3/img/stopwatch_menu_cash.757648cf.svg";